import baseStyled, { css, CSSProp, ThemedStyledInterface } from 'styled-components';
import DF_theme from '@/styles/designFoundation';

const sizes: { [key: string]: number } = {
  half: 1172,
  threeQuarter: 1600
};

type BackQuoteArgs = string[];

interface Media {
  threeQuarter: (...args: BackQuoteArgs) => CSSProp | undefined;
  half: (...args: BackQuoteArgs) => CSSProp | undefined;
  // full: (...args: BackQuoteArgs) => CSSProp | undefined;
}

const media: Media = {
  threeQuarter: () => undefined,
  half: () => undefined
  // full: (...args: BackQuoteArgs) => undefined
};

Object.keys(sizes).reduce((acc: Media, label: string) => {
  switch (label) {
    // case 'full':
    //   acc.full = (...args: BackQuoteArgs) =>
    //     css`
    //       @media only screen and (min-width: ${sizes.full}px) {
    //         ${args}
    //       }
    //     `;
    //   break;
    case 'threeQuarter':
      acc.threeQuarter = (...args: BackQuoteArgs) =>
        css`
          @media only screen and (max-width: ${sizes.threeQuarter}px) {
            ${args}
          }
        `;
      break;
    case 'half':
      acc.half = (...args: BackQuoteArgs) =>
        css`
          @media only screen and (max-width: ${sizes.half}px) {
            ${args}
          }
        `;
      break;
    default:
      break;
  }
  return acc;
}, media);

const theme = {
  media,
  DF_COLOR: DF_theme.color,
  DF_TYPOGRAPHY: DF_theme.typography,
  utils: DF_theme.utils
};

export type Theme = typeof theme;
export const styled = baseStyled as ThemedStyledInterface<Theme>;
export default theme;
